import { useEffect, useRef } from 'react';

/**
 * Vuelve a la página 0 cuando cambia algún filtro (búsqueda, fechas, etc.).
 * Evita quedarse en página 2+ con resultados de una búsqueda nueva.
 */
export function useResetPageOnFilterChange(setPage, page, filters = []) {
  const prevRef = useRef(filters);

  useEffect(() => {
    const prev = prevRef.current;
    const changed =
      filters.length !== prev.length ||
      filters.some((value, index) => value !== prev[index]);
    prevRef.current = filters;
    if (changed && page !== 0) {
      setPage(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- filters as list
  }, [setPage, page, ...filters]);
}
